import { createContext, useContext } from 'react';
import { FunnelMode } from './funnelMode';

export const FunnelModeContext = createContext<FunnelMode>('full');

export function useFunnelMode(): FunnelMode {
  return useContext(FunnelModeContext);
}
